module.exports = __webpack_public_path__ + "img/mobile-compliance.88dcdd31.png";